import React from 'react';

import { Tile } from '../chunk';
import { getServerURL } from '../../util';

//@TODO put in conf
const path = getServerURL();
export default class PostImage extends React.Component {

	render() {

		const file = this.props.file;
        let lightbox = false;
        let linkUrl = path + '/upload/' + file.filename;

		if(file.type.match('image.*')) {
            lightbox = true;
            linkUrl = path + '/thumb/1280/' + file.filename;
        }

		return (
            <Tile url={linkUrl} target="_blank" lightbox={lightbox} key={file.id} transparent={true}>
                <div className='card'>
                    <img style={{margin: 'auto'}} src={path + '/thumb/256/' + file.filename} alt="" />
                </div>
            </Tile>
        );
	}
};


// WEBPACK FOOTER //
// ./src/components/post/PostImage.js